import { Injectable, Provider } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { ITechGroupApiService, ITechGroupApiServiceToken } from './tech-group-api-service.interface';
import { TechGroupClient, TechGroupGetQuery, TechGroupGetQueryResult, TechGroupFeatureListGetQuery, TechGroupFeatureListGetQueryResult, TechGroupFeatureRegisterListGetQuery, TechGroupFeatureRegisterListGetQueryResult } from '../../INTEGRA_Shop_Client';

@Injectable({
  providedIn: 'root'
})
export class TechGroupApiService implements ITechGroupApiService {

  constructor(
    private techGroupClient: TechGroupClient,
  ) { }

  public async swagTechGroupGetAsync(query: TechGroupGetQuery): Promise<TechGroupGetQueryResult> {
    return await firstValueFrom(this.techGroupClient.techGroupGet(query));
  }

  public swagTechGroupFeatureListGet(query: TechGroupFeatureListGetQuery): Observable<TechGroupFeatureListGetQueryResult> {
    return this.techGroupClient.techGroupFeatureListGet(query);
  }

  public swagTechGroupFeatureRegisterListGet(query: TechGroupFeatureRegisterListGetQuery): Observable<TechGroupFeatureRegisterListGetQueryResult> {
    return this.techGroupClient.techGroupFeatureRegisterListGet(query);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const TechGroupApiServiceProvider: Provider[] = [
  { provide: TechGroupClient },
  { provide: ITechGroupApiServiceToken, useExisting: TechGroupApiService }
];
